import { render, staticRenderFns } from "./deleteBlog.vue?vue&type=template&id=d55f9ce6&scoped=true&"
import script from "./deleteBlog.vue?vue&type=script&lang=js&"
export * from "./deleteBlog.vue?vue&type=script&lang=js&"
import style0 from "./deleteBlog.vue?vue&type=style&index=0&id=d55f9ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55f9ce6",
  null
  
)

export default component.exports